export const events = {
  cancelEngagementSurveys: 'Launch Engagement Surveys cancel',
  goToClimateAnalytics: 'Go to Climate analytics',
  goToEnpsAnalytics: 'Go to eNPS analytics',
  goToHC: 'Go to Help Center',
  goToShareFeedback: 'Go to Share Feedback',
  goToTurnoverHC: 'Go to Turnover Help Center',
  startEngagementSurveys: 'Launch Engagement Surveys start',
  submitEngagementSurveys: 'Launch Engagement Surveys submit',
}
